document.addEventListener('DOMContentLoaded', () => {
    const $services_box_2 = document.getElementsByClassName('services-box-2');

    if ( $services_box_2.length )
    {
        const showWhenPropratik = document.querySelector('.showWhenPropratikIsOpen');
        Array.from($services_box_2).forEach((item) => {
            item.addEventListener('click', function () {
                const target = this.getAttribute('data-bs-target') || this.getAttribute('href');

                if (target === '#propratik') {
                    showWhenPropratik.classList.remove('d-none');
                } else {
                    showWhenPropratik.classList.add('d-none');
                }
            });
        });
    }

    function scrollToTargetAdjusted(element){
        var headerOffset = 85;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }



    $('[data-bs-toggle="tab"]').on("click", function(e) {
        const $target_id = $(this).data('bs-target').replace("#", "");
        const $element = document.getElementById($target_id);
        if ( $element )
        {
            scrollToTargetAdjusted($element);
        }
    });
});